import { FC } from "react";
import { Star, StarActive } from "theme/icons";

import { Rating as MuiRating } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledRating = styled(MuiRating)(({ theme }) => {
  return {
    "&.MuiRating-root": {
      color: theme.palette.secondary.main,

      "& .MuiRating-iconEmpty": {
        color: theme.palette.secondary.contrastText,
        fill: theme.palette.secondary.contrastText,
      },
    },
  };
});

type RatingProps = {
  value: number;
};

const Rating: FC<RatingProps> = ({ value }) => {
  return (
    <StyledRating icon={<StarActive />} emptyIcon={<Star />} size="small" readOnly value={value} />
  );
};

export default Rating;
